import "@styles/legal.css";

const selector = document.querySelector<HTMLSelectElement>("[data-legal-document-select]");

selector?.addEventListener("change", () => {
  const nextUrl = selector.value;
  if (nextUrl && nextUrl !== window.location.pathname) {
    window.location.href = nextUrl;
  }
});
